export default "__VITE_ASSET__qIYoNU6HdvlCHpAFFCt_RQ__"